import React from "react";
import Landing from "./Landing";
import WhyUs from "./WhyUs";
import Services from "./Services";
import FAQ from "./FAQ";
import WorkHours from "./WorkHours";
// import imglanding02 from "../assets/landing02.webp";
import LandingDesign from "../assets/landing/landingDesign2.png";
import Booking from "./sub-comps/Booking";
import ReviewsWidget from "./sub-comps/MoreReviews";
import Reviews from "./sub-comps/Reviews";
import ChatButton from "./ChatButton";
function Home() {
  return (
    <>
      {/* <Landing /> */}
      <Landing
        backgroundImage={LandingDesign}
        height="h-screen" 
        overlayColors={{ from: "white/60", to: "white/40" }}
        // overlayColors={{ from: "white/60", to: "white/30" }}
        title="Gardez Votre Sourire Propre Et Brillant"
        description="Nous fournissons des services de soins dentaires complets pour toute
             la famille. Notre équipe expérimentée utilise les technologies les            plus récentes pour fournir des soins de haute qualité."
        buttonText="Explorez Nos Services"
        // onButtonClick={handleButtonClick}
      />
      <WhyUs />
      <Services />
      <FAQ />
      <WorkHours />
      <Reviews/>
      {/* <div className="flex flex-col lg:flex-row lg:items-center justify-center lg:justify-around md:justify-around mt-12 text-center bg-customAqua100/20 py-20">
        <div className="">
          <h3 className="text-2xl font-thin text-customAqua600">
            Prêt à prendre rendez-vous ?
          </h3>
          <p className="text-customAqua600 font-light mt-4">
            Contactez-nous dès maintenant pour prendre rendez-vous et bénéficier
            des meilleurs soins.
          </p>
        </div>
        <div className=" max-w-72">
        <BtnRounded>
          <OpenCalendly />
        </BtnRounded>
        </div>
      </div> */}
      <Booking />
      {/* <ReviewsWidget/> */}
      {/* <ChatButton/> */}
    </>
  );
}

export default Home;
